// src/pages/Privacy.jsx
// Privacy Policy page

import React from 'react';
import { Link } from 'react-router-dom';
import './Legal.css';

export default function Privacy({ theme, toggleTheme }) {
  return (
    <div className="legal-page">
      <header className="legal__header">
        <div className="container legal__header-inner">
          <Link to="/" className="legal__brand">
            <img src="/logo-full.png" alt="BrainAxis" className="legal__logo" />
          </Link>
          <button
            className="legal__theme"
            onClick={toggleTheme}
            aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
          >
            {theme === 'dark' ? '☀' : '☾'}
          </button>
        </div>
      </header>

      <main className="legal__main">
        <div className="container">
          <article className="legal__content">
            <h1>Privacy Policy</h1>
            <p className="legal__updated">Last updated: September 2026</p>

            <p>
              BrainAxis Pty Ltd (ACN 696 339 947) ("BrainAxis", "we", "us") is committed to 
              protecting your privacy. This policy explains how we collect, use, store and 
              disclose personal information, in accordance with the Privacy Act 1988 (Cth) 
              and the Australian Privacy Principles.
            </p>

            <h2>What we collect</h2>
            
            <p>
              <strong>Contact enquiries.</strong> When you use our contact form we collect 
              your name, email address, organisation and the content of your message.
            </p>
            
            <p>
              <strong>Platform accounts.</strong> If you are granted access to our research 
              platform, we collect your email address and authentication details, and records 
              of your activity on the platform.
            </p>
            
            <p>
              <strong>Uploaded research data.</strong> Approved platform users may upload 
              neuroimaging data for analysis. This data must be de-identified before upload. 
              We do not knowingly collect identifiable patient information, and our platform 
              is not intended to receive it.
            </p>
            
            <p>
              <strong>Technical information.</strong> We collect standard server and analytics 
              information such as IP address, browser type and pages visited.
            </p>

            <h2>Why we collect it</h2>
            
            <p>
              We use personal information to respond to enquiries, to provide and administer 
              platform access, to conduct and improve our research and analysis, and to meet 
              our legal obligations. We do not sell personal information, and we do not use 
              it for marketing without consent.
            </p>

            <h2>How it is stored</h2>
            
            <p>
              Information is stored using Google Firebase and Google Cloud Platform services. 
              Data may be stored or processed outside Australia. We take reasonable technical 
              and organisational steps to protect information from misuse, loss, and unauthorised 
              access, including access controls, authentication and encryption in transit.
            </p>

            <h2>Disclosure</h2>
            
            <p>
              We do not disclose personal information to third parties except to service 
              providers who host or support our systems, where required or authorised by law, 
              or with your consent.
            </p>

            <h2>Access and correction</h2>
            
            <p>
              You may request access to the personal information we hold about you, or ask 
              us to correct it, via the <Link to="/#contact">contact form</Link> on our website. We will respond within a 
              reasonable period. You may also ask us to delete your information, and we will 
              do so where we are not required to retain it.
            </p>

            <h2>Complaints</h2>
            
            <p>
              If you believe we have breached the Australian Privacy Principles, contact us 
              via the <Link to="/#contact">contact form</Link> on our website. If you are not satisfied with our response, you may 
              lodge a complaint with the Office of the Australian Information Commissioner 
              at <a href="https://www.oaic.gov.au" target="_blank" rel="noopener noreferrer">www.oaic.gov.au</a>.
            </p>

            <h2>Changes</h2>
            
            <p>
              We may update this policy from time to time. The current version will always 
              be published on this page.
            </p>

            <h2>Contact</h2>
            
            <address>
              BrainAxis Pty Ltd<br />
              Melbourne, Victoria, Australia<br />
              <Link to="/#contact">Contact form</Link>
            </address>
          </article>

          <div className="legal__back">
            <Link to="/">← Back to home</Link>
          </div>
        </div>
      </main>
    </div>
  );
}
